<template>
    <div>
        <div
            v-if="!isEmbedded"
            class="uk-padding logo-struct uk-margin-medium-bottom">
            <div class="uk-grid-collapse" uk-grid>
                <div class="uk-width-expand" />
                <div class="logo-box uk-width-auto">
                    {{ getInfos.transfer.name }}
                    <span class="uk-margin-small-right" />
                    <img
                        :src="apiUrl + '/logos/' + getInfos.logo"
                        class="logo" />
                </div>
            </div>
        </div>

        <slot />
    </div>
</template>

<script>
export default {
    name: 'SwifterStruct',
    props: {
        token: String,
    },

    computed: {
        isEmbedded() {
            const embedded = this.$route.query.embedded;
            return embedded === 'true';
        },
    },
};
</script>

<style lang="scss" scoped>
.logo-box {
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(29, 29, 31, 0.3) !important;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: 500;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
</style>
